import { LadiesMain } from "../../global/ladies-main.ts"

export default class StarsExclusivePost {
    constructor(StarsPost) {
        /**
         * @type {StarsPost}
         */
        this.StarsPost = StarsPost
        this.loadingOverlay = document.getElementById("loading-overlay")

        this.exclusivePostsBuyModal = document.getElementById("exclusivePostsBuyModal")
        this.postTime = document.getElementById("exclusive-post-purchase-post-time")
        this.description = document.getElementById("exclusive-post-purchase-description")
        this.postCoinsCost = document.getElementById("postCoinCost")
        this.postCreatorName = document.getElementById("exclusive-post-purchase-name")
        this.postPictureThumb = document.getElementById("exclusive-post-purchase-post-pic")
        this.userCoinsAmount = userData.userCoinAmount
        this.userHasEnoughCoins = document.getElementById("userEnoughCoinTextExclusivePost")
        this.exclusivePostBuyButton = document.getElementById("exclusivePostsBuyButton")
        this.exclusivePostsNotEnoughCoinsButton = document.getElementById("exclusivePostsNotEnoughCoins")
        this.exclusivePostPurchaseApiUrl = SiteInfo.starsApiUrl + "/api/exclusive-post/purchase"

        this.exclusivePostAfterPurchaseModal = document.getElementById("exclusivePostAfterPurchase")
        this.exclusivePostAfterPurchaseHeading = document.getElementById("exclusivePostAfterPurchaseHeading")
        this.exclusivePostAfterPurchaseMessage = document.getElementById("exclusivePostAfterPurchaseMessage")
        this.exclusivePostAfterPurchaseCoinPurchaseButton = document.getElementById(
            "exclusivePostAfterPurchaseCoinPurchase",
        )
        this.exclusivePostAfterPurchaseMessageCancelButton = document.getElementById("exclusivePostAfterPurchaseCancel")
        const coinBalanceExclusivePosts = document.getElementById("userCoinBalanceExclusivePosts")
        if (coinBalanceExclusivePosts) {
            coinBalanceExclusivePosts.innerText = this.userCoinsAmount.toString()
        }

        window.onload = () => this.reopenModal()
        this.addStarsContentEventListeners()
    }

    addStarsContentEventListeners() {
        if (this.exclusivePostsBuyModal) {
            $(this.exclusivePostsBuyModal).on("show.bs.modal", (/** jQuery.Event */ modalEvent) => {
                this.updateModalWithPostData(modalEvent)
            })

            $(this.exclusivePostsBuyModal).on("hide.bs.modal", (/** jQuery.Event */ modalEvent) =>
                this.hideSubscriptionModalContent(modalEvent),
            )
        }

        if (this.exclusivePostBuyButton) {
            this.exclusivePostBuyButton.addEventListener("click", () => this.purchaseExclusivePost())
        }
    }

    updateModalWithPostData(modalEvent) {
        const starPost = modalEvent.relatedTarget.closest(".stars-post")
        this.postTime.innerText = starPost.querySelector(".postCreationDate").innerText
        this.description.innerText = starPost.querySelector(".post-description").innerText
        this.postCoinsCost.innerText = modalEvent.relatedTarget.dataset.price
        this.postCreatorName.innerText = starPost.querySelector(".creatorProfileName").innerText

        let priceForUser = null
        if (this.postCoinsCost.innerText === "undefined") {
            priceForUser = starPost.querySelector(".priceForUser")
        }

        if (priceForUser !== null) {
            this.postCoinsCost.innerText = priceForUser.getAttribute("data-price")
        }

        if (this.postCoinsCost.innerText === "undefined" && priceForUser === null) {
            this.postCoinsCost.innerText = starPost.querySelector(".priceForFan").getAttribute("data-price")
        }

        this.postCreatorName.innerText = starPost.querySelector(".creatorProfileName").innerText
        this.postPictureThumb.src = starPost.querySelector(".report-advert-thumbnail").src
        this.starId = modalEvent.relatedTarget.dataset.creatorId
        this.postId = starPost.querySelector(".lavert-card").id.slice(5)

        this.pressedBuyButton = document
            .getElementById("post-" + this.postId)
            .querySelector('[data-target="#exclusivePostsBuyModal"]')
            .classList.contains("priceForFan")

        LadiesMain.addHashtagToUrl("exclusive-post-purchase", this.postId)
        LadiesMain.addHashtagToUrl("fan-button", this.pressedBuyButton.toString())

        this.updateBuyButton()
    }
    hideSubscriptionModalContent(modalEvent) {
        LadiesMain.removeHashtagFromUrl("exclusive-post-purchase")
        LadiesMain.removeHashtagFromUrl("fan-button")
    }

    updateBuyButton() {
        if (this.userCoinsAmount < Number.parseInt(this.postCoinsCost.innerText)) {
            this.exclusivePostBuyButton.style.display = "none"
            this.exclusivePostsNotEnoughCoinsButton.style.display = "block"
            this.userHasEnoughCoins.removeAttribute("hidden")
        } else {
            this.exclusivePostBuyButton.style.display = "block"
            this.exclusivePostsNotEnoughCoinsButton.style.display = "none"
            this.userHasEnoughCoins.setAttribute("hidden", "")
        }
    }

    async purchaseExclusivePost() {
        const result = await fetch(this.exclusivePostPurchaseApiUrl, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${userData.accessToken}`,
            },
            body: JSON.stringify({
                user_id: Number.parseInt(userData.userId),
                star_id: Number.parseInt(this.starId),
                post_id: this.postId,
                amount_in_smallest_unit: Number.parseInt(this.postCoinsCost.innerText),
            }),
        }).catch((_) => this.showAfterPurchaseGenericError())

        if (!result) {
            return
        }

        if (result.status !== 200) {
            this.showAfterPurchaseGenericError()
            return
        }

        const processTransactionId = (await result.json()).process_transaction_id
        const pollingCounterMax = 5
        const pollingIntervalMs = 3000

        let pollingCounter = 0
        const pollingInterval = setInterval(async () => {
            pollingCounter += 1
            try {
                const state = await this.fetchProcessTransactionState(processTransactionId)
                if (state.purchase_state === "success") {
                    this.redirectToStarsPostSingleView("success")
                    clearInterval(pollingInterval)
                }
                if (state.purchase_state === "failed") {
                    this.showAfterPurchaseGenericError()
                    clearInterval(pollingInterval)
                }
                // otherwise purchase_state will be "pending"
            } catch (error) {
                clearInterval(pollingInterval)
                this.showAfterPurchaseGenericError()
            }
            if (pollingCounter >= pollingCounterMax) {
                clearInterval(pollingInterval)
                this.redirectToStarsPostSingleView("pending")
            }
        }, pollingIntervalMs)
    }

    async fetchProcessTransactionState(process_transaction_id) {
        return fetch(
            SiteInfo.starsApiUrl + `/api/exclusive-post/state?process_transaction_id=${process_transaction_id}`,
            {
                headers: {
                    Authorization: `Bearer ${userData.accessToken}`,
                },
            },
        ).then((res) => res.json())
    }

    redirectToStarsPostSingleView(purchaseState) {
        window.location.href = `/stars/${this.starId}/${this.postId}#purchase_state=${purchaseState}`
        if (body.id === "single-post") {
            window.location.reload()
        }
    }

    showAfterPurchaseGenericError() {
        this.exclusivePostAfterPurchaseHeading.innerText = "Freischalten fehlgeschlagen"
        this.exclusivePostAfterPurchaseMessage.innerText =
            "Leider konnte der Kauf nicht abgeschlossen werden. Bitte versuche es erneut."
        this.exclusivePostAfterPurchaseCoinPurchaseButton.style.display = "none"
        $(this.loadingOverlay).modal("hide")
        $(this.exclusivePostAfterPurchaseModal).modal("show")
    }

    async reopenModal() {
        if (
            LadiesMain.checkHashtagInUrl("exclusive-post-purchase") &&
            LadiesMain.checkHashtagInUrl("fan-button") &&
            (!this.exclusivePostsBuyModal || this.exclusivePostsBuyModal.style.display !== "block")
        ) {
            const postId = LadiesMain._getHashtagObject()["exclusive-post-purchase"]
            let post = document.getElementById("post-" + postId)

            if (post === null) {
                let postIsVisible = false

                while (!postIsVisible) {
                    await this.StarsPost.loadAdditionalPosts()
                    post = document.querySelector('div[id="post-' + postId + '"]')

                    if (post instanceof HTMLElement) {
                        postIsVisible = true
                    }

                    if (this.StarsPost.loadPostsButton === null) {
                        break
                    }
                }
            }

            if (post === null) {
                return
            }

            setTimeout(() => {
                requestAnimationFrame(() => post.scrollIntoView())
            }, 0)

            let postButtonClass = "priceForUser"
            if (LadiesMain._getHashtagObject()["fan-button"] === "true") {
                postButtonClass = "priceForFan"
            }

            post.querySelector("." + postButtonClass).click()
        }
    }
}
